<template>
  <div class="effect-chart-canvas">
    <div ref="chart" class="effect-chart-canvas__surface"></div>
    <div v-if="empty" class="effect-chart-canvas__empty">暂无数据</div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "EffectChartCanvas",
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    empty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    option: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
    empty() {
      this.renderChart();
    },
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.renderChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    renderChart() {
      if (!this.chart) return;
      if (this.empty) {
        this.chart.clear();
        return;
      }
      this.chart.setOption(this.option || {}, true);
      this.$nextTick(this.resizeChart);
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.effect-chart-canvas {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;

  &__surface {
    width: 100%;
    height: 100%;
    min-height: inherit;
  }

  &__empty {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a2adbc;
    font-size: 12px;
  }
}
</style>
